import { OPEN_TOASTER, CLOSE_TOASTER } from 'constants/actionTypes';

export const openToaster = payload => dispatch => {
  dispatch({
    type: OPEN_TOASTER,
    payload,
  });

  setTimeout(() => {
    dispatch(closeToaster(payload.key));
  }, 1000 * 60 * 3);
};

export const closeToaster = payload => ({
  type: CLOSE_TOASTER,
  payload,
});
